import angular from 'angular';

class BrandsRevokeModalContainer {
  constructor(appEvents, permissions, BRANDS_EVENTS) {
    'ngInject';

    this.appEvents = appEvents;
    this.permissions = permissions;
    this.BRANDS_EVENTS = BRANDS_EVENTS;

    this.removeOpenSubscription = this.appEvents.on(
      this.BRANDS_EVENTS.revoke.open,
      (brand, usersList) => this.openModal(
        brand,
        angular.copy(usersList),
      ),
    );

    this.modalTitle = 'Revoke Permissions';
    this.brand = {};
    this.usersList = [];
    this.open = false;
    this.ownerCaption = '';
  }
  $onDestroy() {
    this.removeOpenSubscription();
  }
  updateModalTitle(users) {
    let title = '';
    if (users.length === 1) {
      const [user] = users;
      title = `Revoke Permissions For ${user.displayName}`;
    } else {
      title = `Revoke Permissions For ${users.length} Selected Users`;
    }

    this.modalTitle = title;
  }
  openModal(brand, usersList) {
    this.brand = brand;
    this.usersList = usersList;
    this.open = true;
    this.updateModalTitle(this.usersList);
    this.ownerCaption = `${this.brand.displayName} [${this.brand.photorank_id}]`;
  }
  closeModal() {
    this.open = false;
    this.appEvents.emit(this.BRANDS_EVENTS.revoke.close);
  }
  saveModal() {
    this.appEvents.emit(this.BRANDS_EVENTS.revoke.save);
    this.closeModal();
  }
}

export default {
  controller: BrandsRevokeModalContainer,
  template: `
    <modal-wrapper
      ng-if="$ctrl.open"
      modal-title="$ctrl.modalTitle"
      on-close="$ctrl.closeModal()"
    >
      <revoke-form-container
        on-save="$ctrl.saveModal()"
        on-cancel="$ctrl.closeModal()"

        owner-label="Account"
        owner-caption="$ctrl.ownerCaption"

        users-list="$ctrl.usersList"
        show-users="true"
        on-users-change="$ctrl.updateModalTitle(users)"
        available-users="$ctrl.brand.user_accounts"

        brands-list="[$ctrl.brand]"
        show-brands="false"
      ></revoke-form-container>
    </modal-wrapper>
  `,
};
